import React from 'react';

const IconUpload = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 16 12 12 8 16" /><line x1="12" y1="12" x2="12" y2="21" /><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" /></svg>;
const IconAi = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2" /><rect x="9" y="9" width="6" height="6" /><line x1="9" y1="1" x2="9" y2="4" /><line x1="15" y1="1" x2="15" y2="4" /><line x1="9" y1="20" x2="9" y2="23" /><line x1="15" y1="20" x2="15" y2="23" /><line x1="20" y1="9" x2="23" y2="9" /><line x1="20" y1="14" x2="23" y2="14" /><line x1="1" y1="9" x2="4" y2="9" /><line x1="1" y1="14" x2="4" y2="14" /></svg>;
const IconAward = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="6" /><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" /></svg>;

const STEPS = [
    { Icon: IconUpload, cls: 'pink', no: '01', t: 'Connect your documents', d: 'Upload files or connect Drive, Dropbox, OneDrive, or SharePoint. One upload populates all modules.' },
    { Icon: IconAi, cls: 'blue', no: '02', t: 'AI auto-fills ~60%', d: 'Clarence interrogates your knowledge base and pre-populates answers. Nothing published without your sign-off.' },
    { Icon: IconAward, cls: 'green', no: '03', t: 'Certify and share', d: 'Bronze, Silver, or Gold certification. Share your pack with controlled access — each investor sees exactly what you choose.' },
];

const CompaniesHowItWorks = () => (
    <section id="how-it-works" className="lp-howto-sec">
        <div className="lp-eyebrow" data-lp-reveal>
            <span className="lp-badge lp-badge--up"><span />How it works</span>
        </div>
        <h2 className="lp-howto-head" data-lp-reveal data-lp-delay="60">Scattered documents to certified pack — in 3 steps.</h2>
        <div className="lp-howto">
            <div className="lp-howto-line" aria-hidden="true" />
            {STEPS.map(({ Icon, cls, no, t, d }, i) => (
                <div className="lp-howstep" key={i} data-lp-reveal data-lp-delay={i * 120}>
                    <div className={`ic ${cls}`}><Icon /></div>
                    <div className="no">{no}</div>
                    <h3>{t}</h3>
                    <p>{d}</p>
                </div>
            ))}
        </div>
    </section>
);

export default CompaniesHowItWorks;
